import React from "react"
import { withTheme } from "emotion-theming"
import { Link } from "react-router"

import styled from "react-emotion"
import "./PageTitle"

const Breadcrumbs = props => {
    const Crumbs = styled("div")`
        margin-top: ${props.theme.small};

        & a {
            color: #ccc;
            font-family: ${props.theme.fontFamily};
            font-size: ${props.theme.fontSize};
        }

        & + div {
            margin-top: 0;
        }
    `
    const Divider = styled("span")`
        color: #ccc;
        font-family: ${props.theme.fontFamily};
        font-size: ${props.theme.fontSize};
        margin: ${props.theme.xsmall};
        &:after {
            content: ${props.divider || "'▸'"};
        }
    `
    const Crumb = props => <Link {...props} />

    let crumbs = props.crumbs || []
    crumbs = crumbs.map(crumb => (
        <Crumb key={crumb.label} to={crumb.link}>
            {crumb.label}
        </Crumb>
    ))
    crumbs = crumbs.map((crumb, i) => [crumb, <Divider key={i} />]).flatten()
    crumbs.pop() // Get rid of the last arrow

    return <Crumbs>{crumbs}</Crumbs>
}

Breadcrumbs.propTypes = {}
Breadcrumbs.displayName = "Breadcrumbs"

export default withTheme(Breadcrumbs)



// WEBPACK FOOTER //
// ./src/ui/components/Breadcrumbs.js